import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

function Badge({ children }:Props) {
    return (
        <Container>
            {children}
        </Container>
    );
}

const Container = styled.div`
    height: 18px;
    border-radius: 4px 12px 12px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px 0 4px;
    font-size: 12px;
    line-height: 1.4;
    font-weight: 500;
    color: var(--color-gray6);
    &:nth-of-type(1) {
        background-color: var(--color-badge-1);
    }

    &:nth-of-type(2) {
        background-color: var(--color-badge-2);
    }

    &:nth-of-type(3) {
        background-color: var(--color-badge-3);
    }

    &:nth-of-type(4) {
        background-color: var(--color-badge-4);
    }

    &:nth-of-type(5) {
        background-color: var(--color-badge-5);
    }
`;

export default Badge;
